import type { SportType } from '@/types/planTypes';

export const sportColors: Record<SportType, string> = {
  swimming: '#AEE2F3',
  running: '#AEE8B0',
  cycling: '#F2A5A5',
};
